import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityConfigInterface, ListMode, RappiderCrudViewModule } from '@rappider/rappider-components';
import { Subscription } from 'rxjs';
import { LoopbackCrudApiService } from '../../services/loopback-crud-api.service';
import { EntityService } from '../../services/entity.service';
import { EntityMetabaseService } from '../../services/entity-metabase.service';
import { ProjectModelControllerService, ProjectModelWithRelations } from '@rappider/rappider-sdk';
import { AiCrudViewComponent } from '../ai-crud-view/ai-crud-view.component';
import { getProjectModelsWithFields, getProjectModelWithFieldsById } from 'libs/shared/src/lib/state-selectors/get-models-with-fields-selector';
import { BrowserStorageManagementService } from 'libs/shared/src/lib/services/browser-storage-management-service/browser-storage-management.service';

@Component({
  selector: 'rappider-project-model-entity',
  standalone: true,
  imports: [
    CommonModule,
    AiCrudViewComponent
  ],
  templateUrl: './project-model-entity.component.html',
  styleUrls: ['./project-model-entity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectModelEntityComponent implements OnInit, OnChanges, OnDestroy {

  @Input() projectModelId: string | undefined; // Optional input to display a specific data table

  projectModels: ProjectModelWithRelations[] | undefined;

  activeEntityConfig: EntityConfigInterface | undefined;
  activeEntityItem: any;
  entityData: Record<string, any[]> = {};

  subscriptions: Subscription[] = [];

  constructor(
    private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef,
    private loopbackCrudApiService: LoopbackCrudApiService,
    private entityService: EntityService,
    private entityMetabaseService: EntityMetabaseService,
    private projectModelControllerService: ProjectModelControllerService,
    private browserStorageManagementService: BrowserStorageManagementService
  ) { }

  ngOnInit() {
    this.subscribeToData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.projectModelId &&
      changes.projectModelId.previousValue &&
      changes.projectModelId.currentValue &&
      changes.projectModelId.currentValue !== changes.projectModelId.previousValue) {
      this.generateEntityConfigForProvidedProjectModel();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  subscribeToData() {
    this.subscriptions = [
      this.getProjectModelsByProjectModelFieldId()
    ];
    this.changeDetectorRef.markForCheck();
  }

  getProjectModelsByProjectModelFieldId() {
    return this.store.select(<any>getProjectModelsWithFields).subscribe(projectModels => {
      this.projectModels = projectModels;
      this.generateEntityConfigForProvidedProjectModel();
    });
  }

  generateEntityConfigForProvidedProjectModel() {
    if (this.projectModels?.length && this.projectModelId) {
      const providedProjectModel = this.projectModels.find(m => m.id === this.projectModelId);
      if (providedProjectModel) {
        const entityMetaConfig = this.entityMetabaseService.generateConfig(providedProjectModel);
        entityMetaConfig.dataFetchedFrom = 'loopback-root-entity-api'; // Default value
        entityMetaConfig.listMode = ListMode.Grid;
        this.activeEntityConfig = this.entityService.generateEntityConfig(entityMetaConfig);
        this.entityData[providedProjectModel.dataTableName] = [];
        this.changeDetectorRef.markForCheck();
      }
    }
  }

  onEntitySelected(entity: EntityConfigInterface) {
    console.log('Entity selected:', entity);
    // this.changeDetectorRef.markForCheck();
  }

  onEntityItemSelected(item: any) {
    console.log('Entity item selected:', item);
    this.activeEntityItem = item;
    this.changeDetectorRef.markForCheck();
  }

  onJoyrideDoneButtonClick(){
    this.browserStorageManagementService.setLocalStorageItem('tour', 'stop');
  }
}
